import React from 'react';

export const LANGUAGES = Object.freeze({
    english: 'english',
    arabic: 'arabic',
});

export const TERMS_OF_SERVICE = Object.freeze({
    tableDataCount: 118,
    header: {
        [LANGUAGES.english]: {
            text: 'Definitions:',
        },
        [LANGUAGES.arabic]: {
            text: 'تعريفات:',
        },
    },
    data: [
        {
            [LANGUAGES.english]: {
                text: 'Agreement means this agreement signed by both parties including the Terms and Conditions. This Agreement is to be read in its entirety and shall prevail over any previous agreements or its addendums. ',
            },
            [LANGUAGES.arabic]: {
                text: 'الاتفاقية: وتعني هذه الاتفاقية التي تم توقيعها من قبل الطرفين بما في ذلك الشروط والأحكام. يتعين قراءة هذه الاتفاقية بالكامل وأنها تسود على أي اتفاقيات سابقة أو ملحقات خاصة بها. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Bank means RAK Bank or any other bank chosen by Edenred in order to open the Customer’s Payroll Account to manage the Payroll Funds. ',
            },
            [LANGUAGES.arabic]: {
                text: 'البنك: ويعني بنك رأس الخيمة أو أي بنك آخر تختاره شركة ايدنريد من أجل فتح حساب لكشوفات مرتبات العميل من أجل إدارة أموال كشوفات المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Cardholder means an Employee of the Customer availing of the Services and approved by Edenred and holding a C3Pay Payroll Card. ',
            },
            [LANGUAGES.arabic]: {
                text: 'حامل البطاقة: ويعني الموظف التابع العميل الذي يستفيد من خدمات شركة ايدنريد والمعتمد لديها والذي يحمل بطاقة المرتبات "C3Pay ". ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Customer means any Customer entering into an agreement with Edenred.',
            },
            [LANGUAGES.arabic]: {
                text: 'العميل: ويعني أي عميل يبرم اتفاقية مع شركة ايدنريد. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Employee/s means any employee of the Customer availing of the Services and approved by Edenred and holding a C3Pay Payroll Card.',
            },
            [LANGUAGES.arabic]: {
                text: 'الموظف/ الموظفين: ويُقصد بهم أي موظف تابع للعميل يستفيد من خدمات شركة ايدنريد والمعتمد لديها ويحمل بطاقة المرتبات "C3Pay ".',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Fee means all fees, charges and expenses (including, without limitation, incurred  charges and additional costs) applicable, from time to time, in relation to the Services payable by the Customer to Edenred.',
            },
            [LANGUAGES.arabic]: {
                text: 'الرسوم: وتعني كافة الرسوم والتكاليف والنفقات (بما في ذلك، بدون حصر، الرسوم المتكبدة والتكاليف الإضافية) المعمول بها، من وقتٍ لآخر، فيما يتعلق بالخدمات التي يدفع في مقابلها العميل للسادة/ ايدنريد.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Intellectual Property Rights means all intellectual property rights any part of the world which includes copyright, design rights, patents, patent applications and any rights to inventions, know-how, trade secrets, trademark and business names, logos and devices and service marks (whether registered or unregistered) and any applications therefore and all rights in confidential information.',
            },
            [LANGUAGES.arabic]: {
                text: 'حقوق الملكية الفكرية: وتعني كافة حقوق الملكية الفكرية في أي جزء من العالم والتي تشمل حقوق النشر وحقوق التصميم وبراءات الاختراع وطلبات براءات الاختراع وأي حقوق في الاختراعات والمعرفة والأسرار التجارية والعلامات التجارية وأسماء الأعمال والشعارات والأجهزة وعلامات الخدمة (سواء كانت مسجلة أو غير مسجلة) وأي طلبات خاصة بها وكافة الحقوق في المعلومات السرية.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Losses means any and all losses, claims, actions, demands, liabilities, costs, expenses and damages of any nature whatsoever and whether or not reasonably foreseeable or avoidable',
            },
            [LANGUAGES.arabic]: {
                text: 'الخسائر: وتعني أي وكافة الخسائر والدعاوى والإجراءات والمطالبات والالتزامات والمصاريف والتكاليف والتعويضات من أي نوع كانت وما إذا كان من الممكن توقعها أو تجنبها بشكل معقول أم لا.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Payment Dates means the dates described in the Payroll File when the Customer intends to disburse the Salaries to its Employees.',
            },
            [LANGUAGES.arabic]: {
                text: 'تواريخ الدفع: وتعني التواريخ المذكورة في ملف كشف المرتبات عندما ينوي العميل صرف المرتبات لموظفيه. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Payroll Account means the bank account with the Bank maintained by Edenred for and on behalf of the Customer for the purpose of holding payroll funds.',
            },
            [LANGUAGES.arabic]: {
                text: 'حساب كشوفات المرتبات: ويعني الحساب المصرفي لدى البنك والذي تحتفظ به شركة ايدنريد لصالح ونيابةً عن العميل لغرض الاحتفاظ بأموال كشوفات المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: ' C3Pay Payroll Card means the plastic debit or pre-paid card issued by Edenred in affiliation with one of the operating banks in the UAE to the Employees and used by the Customer for the exclusive purpose of disbursing Salaries and other compensations related to the Cardholder’s employment with the Customer.',
            },
            [LANGUAGES.arabic]: {
                text: 'بطاقة المرتبات "C3Pay": وتعني بطاقة الخصم أو بطاقة الدفع المسبق البلاستيكية الصادرة عن شركة ايدنريد من خلال الربط مع أحد البنوك العاملة في دولة الإمارات العربية المتحدة للموظفين لغرض استلام المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Payroll File means the electronic file issued by the Customer to Edenred containing details of Salaries to be loaded on the C3Pay Payroll Cards.',
            },
            [LANGUAGES.arabic]: {
                text: 'ملف كشوفات المرتبات: ويعني الملف الإلكتروني الصادر من العميل إلى شركة ايدنريد والذي يحتوي على تفاصيل المرتبات التي سيتم تحميلها على بطاقات المرتبات "C3Pay".  ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Payroll Funds means the funds assigned for Salaries processing.',
            },
            [LANGUAGES.arabic]: {
                text: 'أموال كشوفات المرتبات: وتعني الأموال المخصصة لتجهيز المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Employee File means  file contains  all the information requested by Edenred about the Employees to whom C3Pay Payroll cards will be issued.',
            },
            [LANGUAGES.arabic]: {
                text: 'ملف الموظف: ويعني الملف الذي يحتوي على كافة المعلومات التي طلبتها شركة ايدنريد حول الموظفين الذين سيتم إصدار بطاقات المرتبات "C3Pay" لهم.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Salary/ies means the amount payable by the Customer to its Employees in accordance with the Payroll File. ',
            },
            [LANGUAGES.arabic]: {
                text: 'الراتب/ المرتبات: ويعني المبلغ القابل للدفع من قبل العميل لموظفيه وفقًا لملف كشوفات المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'Service/s means the payroll and card services provided by Edenred pursuant to this Agreement.',
            },
            [LANGUAGES.arabic]: {
                text: 'الخدمة/ الخدمات: وتعني خدمات كشوف المرتبات والبطاقة التي تقدمها شركة ايدنريد وفقًا لهذه الاتفاقية. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'WPS means the UAE Wage Protection System. ',
            },
            [LANGUAGES.arabic]: {
                text: 'نظام حماية الأجور (WPS): ويعني نظام حماية الأجور في دولة الإمارات العربية المتحدة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'SIF means Salary Information File that is used to process Salaries at any of the UAE Central bank agents. This file contains all standard information for Salary processing defined by the UAE Central Bank under the Wage Protection System (WPS).',
            },
            [LANGUAGES.arabic]: {
                text: 'ملف معلومات الراتب (SIF): يعني ملف معلومات الراتب الذي يتم استخدامه لتجهيز المرتبات لدى أي من وكلاء البنك المركزي الإماراتي، ويحتوي هذا الملف على كافة المعلومات القياسية لتجهيز المرتبات المحدّدة من قبل البنك المركزي الإماراتي بموجب نظام حماية الأجور (WPS).',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'WPS person ID means the unique 14 digit number that is provided by Ministry of Labor to each Employee. ',
            },
            [LANGUAGES.arabic]: {
                text: 'هوية الشخص في نظام حماية الأجور: وتعني العدد الفريد المكون من 14 رقم والذي توفره وزارة العمل لكل موظف.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: 'WPS Establishment ID means the unique 13 digit number that is provided by Ministry of Labor to each company.',
            },
            [LANGUAGES.arabic]: {
                text: 'هوية المؤسسة في نظام حماية الأجور: وتعني العدد الفريد المكون من 13 رقم والذي توفره وزارة العمل لكل شركة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.	Range of Services',
            },
            [LANGUAGES.arabic]: {
                text: '1.	مجموعة الخدمات ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.1.	Edenred shall provide the following Services: ',
            },
            [LANGUAGES.arabic]: {
                text: '1.1.	تقدم شركة ايدنريد الخدمات التالية:  ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.1.1	Issuance of C3Pay Payroll Cards to the Employees of the Customer in accordance with any submitted Employee File. ',
            },
            [LANGUAGES.arabic]: {
                text: '1.1.1.	إصدار بطاقات المرتبات "C3Pay" لموظفي العميل وفقًا لأي ملف موظف تم تقديمه. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: <span>1.1.2	Training to the Customer on the usage of Edenred Portal <a className="a-tag" href='https://payroll.ederred.ae/'>https://payroll.ederred.ae/</a> as well as other general procedures regarding the Services.</span>
            },
            [LANGUAGES.arabic]: {
                text: <span>2.1.1.	تدريب العميل على استخدام بوابة شركة ايدنريد <a className="a-tag" href='https://payroll.ederred.ae/'>https://payroll.ederred.ae/</a> بالإضافة إلى الإجراءات العامة الأخرى المتعلقة بالخدمات.</span>,
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.1.3	Providing Service support to the Customer during implementation and on an on-going basis.',
            },
            [LANGUAGES.arabic]: {
                text: '3.1.1	تقديم الدعم الخدماتي للعميل خلال التنفيذ وعلى أساس مستمر.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.1.4	Processing of Payroll Files.',
            },
            [LANGUAGES.arabic]: {
                text: '4.1.1	معالجة ملفات المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.1.5	Ensuring compliance with the Central Bank of the UAE’s regulations on the payment of Salaries, including, without limitation, providing the necessary reporting.',
            },
            [LANGUAGES.arabic]: {
                text: '5.1.1	ضمان الامتثال لأنظمة المصرف المركزي الإماراتي بخصوص دفع المرتبات، بما في ذلك، دون حصر، تقديم التقارير اللازمة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '1.1.6	Training the Employees on the card usage and other services offered.',
            },
            [LANGUAGES.arabic]: {
                text: '6.1.1	تدريب الموظفين على استخدام البطاقة والخدمات المقدمة الأخرى.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: "1.2 The Customer undertakes that every issued C3Pay Card to their respective Employees shall only and exclusively be used for the purpose of disbursing the Cardholders' Salaries and similar forms of remuneration.",
            },
            [LANGUAGES.arabic]: {
                text: '2.1 يتعهد العميل بأن كل بطاقة C3PAY  صادرة لموظفية سيتم استخدامها فقط وحصريا لغرض صرف الرواتب ومافي حكمها لحاملى البطاقات ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '2.	Issuance of C3Pay Payroll Cards ',
            },
            [LANGUAGES.arabic]: {
                text: '2.	إصدار بطاقات المرتبات "C3Pay":',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '2.1.	Edenred shall make available to the Customer the required Employee File to be submitted for card ordering.  The Employee File will be sent to the Customer via email and made available on the Edenred corporate portal.',
            },
            [LANGUAGES.arabic]: {
                text: '1.2.	توفر شركة ايدنريد للعميل الملف المطلوب للموظف والذي يتم تقديمه لطلب البطاقة. سيتم إرسال ملف الموظف إلى العميل عبر البريد الإلكتروني وإتاحته على بوابة شركة ايدنريد.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '2.2.	Edenred shall have the right to decline any Employee Application that is not filled properly or that contains untrue, inaccurate or misleading information. Edenred further reserves the right to decline to issue C3Pay Payroll Cards to any Employee at its sole discretion for any valid reason.  The Customer will perform Know Your Customer (KYC), and provide all necessary documents, after agreeing that only Employees whose identity they are able to verify, will be nominated as applicants for C3Pay Payroll Cards.',
            },
            [LANGUAGES.arabic]: {
                text: '2.2.	يحق لشركة ايدنريد رفض أي طلب خاص بموظف ما لم يتم تعبئته بشكل صحيح أو الذي يحتوي على معلومات غير صحيحة أو غير دقيقة أو مضللة. تحتفظ شركة ايدنريد كذلك بالحق في رفض إصدار بطاقات المرتبات "C3Pay" لأي موظف وفقًا لتقديرها الخاص لأي سبب وجيه. يقوم العميل بتنفيذ إجراء "أعرف عميلك"، وتقديم كل المستندات اللازمة، بعد الموافقة على أنه فقط الموظفين الذين يمكنهم التحقق من هويتهم، سيتم ترشيحهم كمتقدمين للحصول على بطاقات المرتبات "C3Pay".',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '2.3.	The Customer shall provide Employee File to Edenred, Edenred shall process and deliver the C3Pay Payroll Cards to the Customer within a period of seven (7) to ten (10) working days from the date of receiving the Employee File.',
            },
            [LANGUAGES.arabic]: {
                text: '3.2	يقوم العميل بتقديم ملف الموظف لشركة ايدنريد، وتقوم الأخيرة بمعالجة بطاقات المرتبات "C3Pay" وتسليمها للعميل في غضون سبعة (7) إلى عشرة (10) أيام عمل من تاريخ استلام ملف الموظف.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '2.4.	Edenred is responsible for delivering all issued C3Pay Payroll Cards to each Employee who shall be responsible to activate their own Card to be able to use; if the Card is delivered to the Customer, the latter is responsible for delivering the Card to the respective Employee.',
            },
            [LANGUAGES.arabic]: {
                text: '4.2	 تكون شركة ايدنريد مسؤولة عن تسليم كل ما تصدره من بطاقات المرتبات "C3Pay" لكل موظف والذي يكون مسؤولاً عن تفعيل بطاقته الخاصة ليتمكن من استخدامها؛ وإذا تم تسليم البطاقة للعميل، يكون هذا الأخير مسؤول عن تسليم البطاقة للموظف المعني.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '2.5.	The Customer will have access, through the Edenred Corporate Portal, to a list containing the total number of C3Pay Payroll Cards Issued, names of the Employees to whom the C3Pay payroll cards are issued and their respective customer ID number.',
            },
            [LANGUAGES.arabic]: {
                text: '5.2	 يمكن للعميل الوصول، من خلال بوابة ايدنريد للشركات، إلى مجموعة تحتوي على العدد الإجمالي لبطاقات المرتبات "C3Pay" التي تم إصدارها، وأسماء الموظفين الذين تم إصدار بطاقات المرتبات "C3Pay" لهم ورقم العميل الخاص بهم.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.	Payroll Disbursement Process',
            },
            [LANGUAGES.arabic]: {
                text: '3.	عملية صرف كشوفات المرتبات',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.1.	Subject to any other Section of this Agreement, Edenred shall act upon any Payroll File received from the Customer and shall load the C3Pay Payroll Cards with the Salaries as stipulated in the Payroll File. ',
            },
            [LANGUAGES.arabic]: {
                text: '1.3.	مع مراعاة أي قسم آخر من هذه الاتفاقية، تتصرف شركة ايدنريد بناءًا على أي ملف كشوفات مرتبات مستلم من العميل وتقوم بتحميل بطاقات المرتبات C3Pay بالمرتبات وفق ما هو منصوص عليه في ملف كشوف المرتبات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.2.	Edenred shall not act upon any Payroll File that contains any discrepancy, error or omission. Edenred shall notify the Customer upon discovery of errors  in the Payroll File and the Customer shall immediately rectify such information by issuing a new Payroll File.',
            },
            [LANGUAGES.arabic]: {
                text: '2.3.	لا تتصرف شركة ايدنريد حيال أي ملف كشوفات مرتبات يحتوي على أي تناقض، أو خطأ أو سهو. تقوم شركة ايدنريد بإخطار العميل عند اكتشاف الأخطاء في ملف كشوفات المرتبات ويتعين على العميل تصحيح هذه المعلومات على الفور عن طريق إصدار ملف كشوفات مرتبات جديد.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.3.	Edenred will facilitate same day disbursement on condition that Payroll File shall be received by Edenred and Payroll Funds shall be received and cleared in our Payroll Account not later than 14:30 (GST) Monday to Saturday.',
            },
            [LANGUAGES.arabic]: {
                text: '3.3	سوف تسعى شركة ايدنريد لتسهيل صرف المرتبات  في نفس اليوم شريطة أن يتم استلام ملف كشوفات المرتبات من قبل شركة ايدنريد وأن يتم استلام وأداء الأموال الخاصة بالمرتبات في حساب كشوف المرتبات لدينا في موعد لا يتجاوز الساعة 14:30 (بتوقيت الخليج) من الاثنين إلى السبت.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.3.1.	Edenred shall not be responsible for any delay in disbursing Salaries and shall not be held liable for any claim and/or penalties imposed  by respective authorities in connection with performing the Services if the Payroll File is not received by Edenred within the above subscribed period and if Payroll funds have not been received and cleared in our Payroll Account.',
            },
            [LANGUAGES.arabic]: {
                text: '1.3.3	لن تكون شركة ايدنريد مسؤولة عن أي تأخير في صرف المرتبات ولن تكون مسؤولة عن أي مطالبة و/أو عقوبات مفروضة من قبل السلطات المعنية فيما يتعلق بأداء الخدمات إذا لم يتم استلام ملف كشوف المرتبات من قبل شركة ايدنريد خلال الفترة أعلاه وإذا لم يتم استلام الأموال الخاصة بالمرتبات وتسويتها في حساب المرتبات لدينا.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.3.2.	Edenred endeavors complete payments with the above, however any delay in processing Salary disbursement as a result of deficiencies shall be at the sole risk and liability of the Customer.',
            },
            [LANGUAGES.arabic]: {
                text: '2.3.3	تعمل شركة ايدنريد على سداد كامل المدفوعات وفق ما ورد أعلاه، ولكن أي تأخير في معالجة صرف الراتب نتيجة لتقصير ما سيتحمل مخاطره ويكون على مسؤولية العميل وحده.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.4.	WPS Procedures (if applicable):',
            },
            [LANGUAGES.arabic]: {
                text: '3.4	 الإجراءات الخاصة بنظام حماية الأجور (إن كانت قابلة للتطبيق):',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.4.1	The Customer shall ensure to provide all the accurate labor card numbers, WPS person ID and WPS Establishment ID numbers in the Cardholder File (Employee File) or update them directly on the Edenred Corporate Portal to process WPS.',
            },
            [LANGUAGES.arabic]: {
                text: '1.3.4	يتعين على العميل ضمان تقديم كافة الأرقام الصحيحة لبطاقات العمل والهوية الشخصية على نظام حماية الأجور وهوية المؤسسة في نظام حماية الأجور في ملف حامل البطاقة (ملف الموظف) أو تحديثها مباشرةً من خلال بوابة ايدنريد للشركات لمعالجة نظام حماية الأجور.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.4.2	The Customer should upload the SIF file on the corporate portal and choose a 2nd admin user “where applicable” to validate the SIF file uploaded.',
            },
            [LANGUAGES.arabic]: {
                text: '2.4.3	يتعين على العميل تحميل ملف معلومات الراتب على البوابة الخاصة بالشركات واختيار مستخدم إداري ثاني "حيثما يكون قابلًا للتطبيق" للمصادقة على صحة معلومات الرواتب الذي تم تحميله.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.4.3	Once verified, Edenred will process the SIF as long as the funds verified  to be available on the account.',
            },
            [LANGUAGES.arabic]: {
                text: '3.4.3	بمجرد التحقق من ذلك، تقوم شركة ايدنريد بمعالجة ملف معلومات الراتب طالما أنه تم التحقق من توفر الأموال في الحساب.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.4.4	Debit adjustments are not allowed in case if Salary processed through WPS. Once the Salary is notified to WPS, no debit adjustment can be done. Any Customer generated errors, adjustments on WPS Salary disbursement, can only be rectified/reversed by Edenred through WPS process via Central Bank (salary reversal fees apply).',
            },
            [LANGUAGES.arabic]: {
                text: '4.4.3	لا يُسمح بتعديلات الخصم في حال معالجة الراتب من خلال نظام حماية الأجور. بمجرد الإخطار بالراتب لنظام حماية الأجور، لا يمكن إجراء أي تعديل على الخصم. لا يمكن تصحيح/ إبطال أي أخطاء ناجمة عن العميل أو تعديلات في صرف المرتبات على نظام حماية الأجور، إلا من خلال شركة ايدنريد من خلال عملية نظام حماية الأجور عبر البنك المركزي (تطبق رسوم إبطال الراتب).',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '3.4.5	The Customer shall take full responsibility for the authenticity of the details mentioned in the Edenred online portal and SIF. Any complaint, claim, losses or damages arising out of any discrepancy/deficiency in the contents of the SIF shall be solely handled and borne by the Customer.',
            },
            [LANGUAGES.arabic]: {
                text: '5.4.3	يتحمل العميل كامل المسؤولية عن صحة التفاصيل المذكورة على بوابة شركة ايدنريد وملف معلومات الراتب. يعالج ويتحمل العميل أي شكوى أو مطالبة أو خسائر أو تعويضات ناشئة عن أي تناقض/ نقص في محتويات ملف معلومات الراتب.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '4.	Payroll Disbursal Account:',
            },
            [LANGUAGES.arabic]: {
                text: '4.	حساب صرف المرتبات:',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '4.1.	Customer must use the Account below to transfer funds for the purpose of the Monthly Payroll. ',
            },
            [LANGUAGES.arabic]: {
                text: '1.4	يجب على العميل استخدام الحساب أدناه من أجل تحويل الأموال لغرض كشوفات المرتبات الشهرية: ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: <span>4.2.	Upon transferring the funds, the Customer must upload proof of the funds transferred on the Edenred payroll portal <a href='https://payroll.edenred.ae/.' className='a-tag'> https://payroll.edenred.ae/.</a></span>,
            },
            [LANGUAGES.arabic]: {
                text: <span>2.4	عند تحويل الأموال، يجب على العميل تحميل إثبات بخصوص الأموال المحوّلة من خلال بوابة شركة ايدنريد للمرتبات <a href='https://payroll.edenred.ae/.' className='a-tag'> https://payroll.شركة ايدنريد.ae/.</a> </span>,
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.	Customer’s Covenants, Fees, Indemnity and Liability ',
            },
            [LANGUAGES.arabic]: {
                text: '5.	تعهدات ورسوم وتعويضات ومسؤولية العميل: ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.1.	The Customer warrants that they fully understand the procedures and requirements for the provision of the Services as set out in this Agreement.',
            },
            [LANGUAGES.arabic]: {
                text: '1.5	يتعهد العميل بأنه فهم تمامًا الإجراءات والمتطلبات الخاصة بتقديم الخدمات كما هو منصوص عليه في هذه الاتفاقية.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.2.	The Customer should provide the name and contact details of the person assigned an admin access to Edenred Corporate Portal.',
            },
            [LANGUAGES.arabic]: {
                text: '2.5	يتعين على العميل تقديم الاسم وتفاصيل الاتصال الخاصة بالشخص الذي تم تخصيص له الدخول والقيام بالتعديل  على حساب العميل الخاص ببوابة شركة ايدنريد للشركات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.3.	With any Payroll File, the Customer shall ensure that the Salaries funds have been credited one (1) working day in advance to the Payroll Account in order to meet the total Salaries amounts on the Payroll File and to the nominated Edenred fee account to meet the applicable Fees.',
            },
            [LANGUAGES.arabic]: {
                text: '3.5 	في كل حالة لأي ملف كشوف مرتبات، يتعين على العميل التأكد من أن الأموال الخاصة بالمرتبات قد تم إيداعها قبل يوم عمل واحد (1) في حساب كشوفات المرتبات من أجل تلبية إجمالي مبالغ المرتبات في ملف كشوفات المرتبات وإلى حساب رسوم شركة ايدنريد المحدد لتلبية الرسوم المطبقة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.4.	The Customer shall pay any and all applicable fees mentioned in this Agreement in relation to the Services provided, including, without limitation: card issuance fee which must be paid upon signing this Agreement, and a monthly fee set forth in Schedule of Charges. Additionally, a card renewal fee, after expiry, of AED 5 per card and card account closure fee after cancellation of AED 4 per card will be charged. This must be paid by the Customer within thirty (30) days from the date of the invoice issuance.',
            },
            [LANGUAGES.arabic]: {
                text: '4.5	يتعين على العميل دفع أي وكافة الرسوم السارية المذكورة في هذه الاتفاقية فيما يتعلق بالخدمات المقدمة، بما في ذلك، دون حصر: رسوم إصدار البطاقة والتي يجب دفعها عند توقيع هذه الاتفاقية، والرسوم الشهرية المنصوص عليها في جدول الرسوم. بالإضافة إلى ذلك، سيتم فرض رسوم تجديد البطاقة، بعد انتهاء الصلاحية، بقيمة 5 دراهم إماراتية لكل بطاقة ورسوم إغلاق حساب البطاقة بعد الإلغاء بقيمة 4 دراهم إماراتية لكل بطاقة؛ ويجب دفع هذا من قبل العميل خلال ثلاثين (30) يومًا من تاريخ إصدار الفاتورة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.5.	The Fees do not include any applicable value-added tax ("VAT") or any other taxes that may be applicable in the future by the respective authorities. Any VAT, if applicable, will be payable by the Customer. This additional amount will be added to the invoice at the appropriate rate.',
            },
            [LANGUAGES.arabic]: {
                text: '5.5	لا تشمل الرسوم أي ضريبة قيمة مضافة سارية أو أي ضرائب أخرى قد تكون قابلة للتطبيق في المستقبل من قبل السلطات المعنية. أي ضريبة قيمة مضافة، إن وجدت، ستكون مستحقة الدفع من قبل العميل. سيتم إضافة هذا المبلغ الإضافي إلى الفاتورة بالمعدّل المناسب',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.6.	ATM Waiver - All Free ATM Waiver on Cash Withdrawal at any Bank ATM “that has its logo in the card” and All Free on Edenred ATMs in the UAE.',
            },
            [LANGUAGES.arabic]: {
                text: '6.5.	استثناء ماكينات الصرافة – كافة ماكينات الصرافة مجانية عند السحب النقدي من أي ماكينة صرافة تابعة للبنك الموجود على البطاقة وايضا عندما يتعلق الأمر بماكينات صرافة شركة ايدنريد في الإمارات العربية المتحدة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.7.	The Customer agrees that Edenred may amend the Fees set forth in Schedule of Charges at its sole discretion after giving a 30 day notice to the Customer.',
            },
            [LANGUAGES.arabic]: {
                text: '7.5.	يوافق العميل على أنه يجوز لشركة ايدنريد تعديل الرسوم الواردة في جدول الرسوم وفقًا لتقديرها الخاص بعد تقديم إشعار بمدة 30 يومًا للعميل قبل تغير الرسوم. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.8.	This Agreement shall enter in full force as of the date of signing the Agreement and shall be valid for one year (hereinafter the “Initial Term”)  and shall be automatically renewed for additional term (hereinafter a “Renewal Term”. For the avoidance of any doubt, the Initial Term and any Renewal Term are collectively referred to in this Agreement to as the “Term”) unless otherwise agreed by the Parties, during the term of the agreement the monthly fee shall be adjusted by a percentage equal to the percentage increase in the UAE inflation rate. Such adjustment shall take place only once per year on a calendar-year basis.',
            },
            [LANGUAGES.arabic]: {
                text: '8.5.	تدخل هذه الاتفاقية حيز التنفيذ بالكامل اعتبارًا من تاريخ توقيع الاتفاقية وستكون صالحة لمدة عام واحد (يشار إليها فيما يلي باسم "المدة الأولية") ويتم تجديدها تلقائيًا لمدة إضافية (يشار إليها فيما يلي بـ "مدة التجديد"). لتجنب أي شك، يُشار إلى المدة الأولية وأي مدة تجديد مجتمعين في هذه الاتفاقية باسم "المدة") ما لم يتم الاتفاق على خلاف ذلك بين الطرفين، خلال مدة الاتفاقية، يتم تعديل الرسوم الشهرية بنسبة مئوية تساوي النسبة المئوية لزيادة معدل التضخم في دولة الإمارات العربية المتحدة، ويتم هذا التعديل مرة واحدة فقط في السنة على أساس السنة الميلادية.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.9.	The Customer hereby undertakes to inform its Employees and always keep them informed of any change(s) or amendment(s) to this Agreement, as and when it occurs.',
            },
            [LANGUAGES.arabic]: {
                text: '9.5	يتعهد العميل بموجب هذا بإخطار موظفيه وجعلهم دائمًا على علم بأي تغيير (تغييرات) أو تعديل (تعديلات) على هذه الاتفاقية، كيفما وعند حدوثها.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.10.	Edenred shall not be liable, in any way for any files processed in the Edenred system once the file submitted and/or approved.',
            },
            [LANGUAGES.arabic]: {
                text: '10.5.	لن تكون شركة ايدنريد مسؤولة بأي شكلٍ من الأشكال عن أي ملفات تمت معالجتها على نظامها، بمجرد إرسال الملف و/أو الموافقة عليه.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '5.11.	Customer must use the following Account for the transfer of Edenred invoice payment.',
            },
            [LANGUAGES.arabic]: {
                text: '11.5.	يجب على العميل استخدام الحساب التالي من أجل عملية تحويل سداد فاتورة شركة ايدنريد:',
            },
        },
        {
            [LANGUAGES.english]: {
                text: <table data-tablestyle="MsoTableGrid" data-tablelook="1184" aria-rowcount="7" className="table-data">
                    <tbody>
                        <tr aria-rowindex="1">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Bank Name</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">RAS AL KHAIMAH BANK (RAK BANK)</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="2">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Bank Branch</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Umm&nbsp;Hurrair, Dubai</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="3">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Account Name</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">EDENRED PREPAID CARDS MANAGEMENT SERVICES L.L.C</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="4">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Account Number</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">0332545791001</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="5">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">IBAN Number</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">AE830400000332545791001</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="6">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Swift Code</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">NRAKAEAK</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="7">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Routing Code</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">740810000</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                    </tbody>
                </table>,
            },
            [LANGUAGES.arabic]: {
                text: <table data-tablestyle="MsoTableGrid" data-tablelook="1184" aria-rowcount="7" className="table-data">
                    <tbody>
                        <tr aria-rowindex="1">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">اسم البنك</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">بنك رأس الخيمة </span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="2">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">فرع البنك </span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">أم هرير، دبي </span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="3">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">أسم الحساب </span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">ايدنريد لخدمات إدارة بطاقات الدفع المسبق ذ.م.م </span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="4">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">رقم الحساب </span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">0332545791001</span>
                                </b>
                                <span data-ccp-props="{}">&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="5">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">رقم الآيبان </span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">AE830400000332545791001</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="6">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">سويفت كود NRAKAEAK</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">NRAKAEAK</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                        <tr aria-rowindex="7">
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">Routing Code</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                            <td data-celllook="0">
                                <b>
                                    <span data-contrast="none">740810000</span>
                                </b>
                                <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                            </td>
                        </tr>
                    </tbody>
                </table>,
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.	Edenred Covenants ',
            },
            [LANGUAGES.arabic]: {
                text: '6.	تعهدات شركة ايدنريد ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.1.	On the Payment Dates and subject to this Agreement, Edenred shall load the C3Pay payroll cards for those Employees listed in the Payroll File with their respective Salaries',
            },
            [LANGUAGES.arabic]: {
                text: '1.6	في تواريخ السداد وبناءًا على هذه الاتفاقية، تقوم شركة ايدنريد بتحميل بطاقات مرتبات C3Pay للموظفين المدرجين في ملف كشوفات المرتبات بمرتباتهم الخاصة بهم.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.2.	Edenred shall carry out the Services in a diligent and professional manner and in compliance with all UAE applicable laws, regulations and appropriate banking practices.',
            },
            [LANGUAGES.arabic]: {
                text: '2.6	  يتعين على شركة ايدنريد تنفيذ الخدمات باجتهاد ومهنية ووفقًا لكافة القوانين واللوائح المعمول بها في دولة الإمارات العربية المتحدة والممارسات المصرفية المناسبة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.3.	Edenred shall not perform the Services unless notified to do so by the Customer. Unless the Payroll File is transmitted and received by Edenred in the manner as prescribed in this Agreement and any related service level agreements, no Salary shall be loaded into any C3Pay Payroll Card.',
            },
            [LANGUAGES.arabic]: {
                text: '3.6	لا يجوز لشركة ايدنريد أداء الخدمات ما لم يتم إخطارها بذلك من طرف عميل. وما لم يتم إرسال ملف كشوف المرتبات واستلامه من قبل شركة ايدنريد بالطريقة المذكورة في هذه الاتفاقية وأي اتفاقيات بمستوى الخدمة ذات صلة، فلن يتم تحميل أي راتب في أي بطاقة كشوف مرتبات C3Pay.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.4.	Edenred shall provide a monthly invoice for any Fees indicating the number of active C3Pay payroll cards per Customer for billing purposes. The billing cycle is set from the 26th of the previous month to the 25th of the current month. All invoices raised for a particular month shall be paid within thirty (30) days from the date of invoice.',
            },
            [LANGUAGES.arabic]: {
                text: '4.6	يتعين أن تقدم شركة ايدنريد فاتورة شهرية لأي رسوم وتشير فيها إلى عدد بطاقات كشوفات المرتبات النشطة C3Pay لكل عميل لأغراض الفوترة. تم تحديد دورة الفوترة لتكون من اليوم السادس والعشرين من الشهر السابق إلى اليوم الخامس والعشرين من الشهر الحالي. يتعين دفع كافة الفواتير المقدّمة بخصوص شهر معين في غضون ثلاثين (30) يومًا من تاريخ الفاتورة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: <div>
                    <span>6.5.	Edenred reserves the right to suspend services of Customer after 45 days of non-payment from the date of invoice.</span>
                    <table data-tablestyle="MsoTableGrid" data-tablelook="1184" aria-rowcount="7" className="table-data">
                        <tbody>
                            <tr aria-rowindex="1">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Bank Name</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">RAS AL KHAIMAH BANK (RAK BANK)</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="2">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Bank Branch</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Umm&nbsp;Hurrair, Dubai</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="3">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Account Name</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">EDENRED PREPAID CARDS MANAGEMENT SERVICES L.L.C</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="4">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Account Number</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">0332545791001</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="5">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">IBAN Number</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">AE830400000332545791001</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="6">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Swift Code</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">NRAKAEAK</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="7">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">Routing Code</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">740810000</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>,
            },
            [LANGUAGES.arabic]: {
                text: <div>
                    <span>5.6	تحتفظ شركة ايدنريد بالحق في إيقاف الخدمات عن العميل بعد 45 يوم من عدم السداد من تاريخ الفاتورة.</span>
                    <table data-tablestyle="MsoTableGrid" data-tablelook="1184" aria-rowcount="7" className="table-data">
                        <tbody>
                            <tr aria-rowindex="1">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">اسم البنك</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">بنك رأس الخيمة </span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="2">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">فرع البنك </span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">أم هرير، دبي </span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="3">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">اسم الحساب شركة ايدنريد</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">ايدنريد لخدمات إدارة بطاقات الدفع المسبق ذ.م.م </span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="4">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">رقم الحساب </span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">0332545791001</span>
                                    </b>
                                    <span data-ccp-props="{}">&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="5">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">رقم الآيبان </span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">AE830400000332545791001</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="6">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">سويفت كود</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">NRAKAEAK</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                            <tr aria-rowindex="7">
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">رمز التوجيه</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                                <td data-celllook="0">
                                    <b>
                                        <span data-contrast="none">740810000</span>
                                    </b>
                                    <span data-ccp-props='{"335551550":6,"335551620":6}'>&nbsp;</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>,
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.6.	Customer should transfer the invoice amount within the 30 days from the date of issuance of the invoice. The invoice amount should be transferred to the same Bank Account, details of which are set forth in Section 5.11. Funds transferred for the purpose of invoice payment will have to be supported by a bank transfer receipt mailed to Edenred.',
            },
            [LANGUAGES.arabic]: {
                text: '6.6.	يجب على العميل تحويل مبلغ الفاتورة خلال 30 يومًا من تاريخ إصدار الفاتورة. يتعين تحويل مبلغ الفاتورة إلى نفس الحساب المصرفي التي ترد تفاصيله في القسم 11.5. تكون الأموال المحولة لغرض دفع الفاتورة مصحوبة بإيصال تحويل مصرفي يتم إرساله بالبريد إلى شركة ايدنريد.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '6.7.	Any funds transferred or loaded into the C3Pay Payroll Cards shall continue to be owned by the Employee even after termination of their employment with the Customer or expiration of the C3Pay Payroll Card; in both cases Edenred shall provide the Customer with the necessary channels to ensure that any such funds remaining in the C3Pay Payroll Card can be made available to the Employee up to 90 day from the date of the termination of the employment of the Employee with the Customer.',
            },
            [LANGUAGES.arabic]: {
                text: '7.6.	تظل أي أموال يتم تحويلها أو تحميلها في بطاقات كشوفات المرتبات C3Pay مملوكة للموظف حتى بعد انتهاء عملهم مع العميل أو انتهاء صلاحية بطاقة كشوفات المرتبات C3Pay ؛ وفي كلتا الحالتين، يتعين على شركة ايدنريد توفير القنوات اللازمة للعميل لضمان إتاحة أي أموال متبقية في بطاقة كشوفات المرتبات C3Pay  للموظف إلى غاية 90 يومًا من تاريخ إنهاء توظيف الموظف لدى العميل.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.	Term and Termination',
            },
            [LANGUAGES.arabic]: {
                text: '7.	المدة والإنهاء:',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.1.	This Agreement shall commence on the date it is signed by the parties and shall continue until terminated.',
            },
            [LANGUAGES.arabic]: {
                text: '1.7	 تبدأ هذه الاتفاقية في التاريخ الذي يتم فيه التوقيع عليها من قبل الأطراف وتستمر حتى يتم إنهاؤها.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.2.	The Customer or Edenred may terminate this Agreement with or without any cause by serving the other party a ninety (90) days (“Notice Period”) written notice of termination.',
            },
            [LANGUAGES.arabic]: {
                text: '2.7	يجوز للعميل أو شركة ايدنريد إنهاء هذه الاتفاقية بسبب أو بدون أي سبب من خلال تقديم إشعار خطي مدته 90 يومًا بإنهاء الاتفاقية للطرف الآخر ("فترة الإشعار").',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.3.	Without prejudice to any other rights, the Customer and Edenred shall have the right to terminate this Agreement by immediate written notice if:',
            },
            [LANGUAGES.arabic]: {
                text: '3.7	مع عدم الإخلال بأي حقوق أخرى، يحق للعميل وشركة ايدنريد إنهاء هذه الاتفاقية بموجب إشعار خطي فوري إذا:',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.3.1.	the other party commits a material breach of this Agreement and fails to remedy the breach within seven (7) days upon receipt of a written notice to do so; or',
            },
            [LANGUAGES.arabic]: {
                text: '1.3.7	ارتكب الطرف الآخر خرقًا ماديًا لهذه الاتفاقية وأخفق في تصحيح الخرق في غضون سبعة (7) أيام من استلام إشعار خطي للقيام بذلك؛ أو',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.3.2.	the other party commits any act of bankruptcy or insolvency or compounds with its creditors or a petition or receiving order in bankruptcy is presented or made against either party or a petition for an administration order is presented in relation to either party or a resolution or petition to wind up either party is passed or presented (other than for merger or amalgamation) or receiver or administrative receiver is appointed.',
            },
            [LANGUAGES.arabic]: {
                text: '2.3.7	إذا ارتكب الطرف الآخر أي عمل من أعمال الإفلاس أو الإعسار أو عقد صلح مع دائنيه أو تم تقديم أو رفع التماس أو استلام أمر بالإفلاس أو تقديمه ضد أي من الطرفين أو تقديم التماس لأمر إداري فيما يتعلق بأي من الطرفين أو قرار أو طلب بتصفية أي من الطرفين تم تمريره أو تقديمه (بخلاف لغرض الدمج أو الاندماج) أو يتم تعيين حارس قضائي أو حارس إداري. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.4.	During any Notice Period, Edenred shall continue to provide the Service to the Customer pursuant to this Agreement and the Customer will pay all Fees relating to such Services.',
            },
            [LANGUAGES.arabic]: {
                text: '4.7	خلال أي فترة إشعار، تستمر شركة ايدنريد في تقديم الخدمة للعميل وفقًا لهذه الاتفاقية وسيدفع العميل كافة الرسوم المتعلقة بتلك الخدمات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '7.5.	The termination of this Agreement shall not affect any rights which have accrued to the parties before termination.',
            },
            [LANGUAGES.arabic]: {
                text: '5.7	 لن يؤثر إنهاء هذه الاتفاقية على أي حقوق تراكمت وأصبحت مستحقة للأطراف قبل الإنهاء.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '8.	Intellectual Property',
            },
            [LANGUAGES.arabic]: {
                text: '8.	الملكية الفكرية:',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '8.1.	The Customer agrees that Intellectual Property Rights in any part of the world which are at any time created by or deriving from the business of or owned by Edenred, developed by Edenred or are the existing property of Edenred are exclusively owned by Edenred and the Customer will not use or infringe such Intellectual Property Rights.',
            },
            [LANGUAGES.arabic]: {
                text: '1.8	يوافق العميل على أن حقوق الملكية الفكرية في أي جزء من العالم، والتي تم إنشاؤها في أي وقت من طرف أو مشتقة من الأعمال التجارية لشركة ايدنريد أو المملوكة لها أو التي طورتها شركة ايدنريد أو أنها تحت الملكية الحالية لشركة ايدنريد هي حقوق مملوكة حصريًا لشركة ايدنريد ولن يقوم العميل باستعمال أو انتهاك حقوق الملكية الفكرية.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '8.2.	The Customer agrees that all Intellectual Property Rights in all documents and materials specifically produced by or on behalf of Edenred in connection with or relating to this Agreement shall vest in and belong to Edenred.',
            },
            [LANGUAGES.arabic]: {
                text: '2.8	يوافق العميل على أن تكون كافة حقوق الملكية الفكرية في كافة المستندات والمواد الناتجة خصوصًا عن شركة ايدنريد أو بالنيابة عنها فيما يتعلق أو يتصل بهذه الاتفاقية ملكًا لشركة ايدنريد وتعود لها.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.	General',
            },
            [LANGUAGES.arabic]: {
                text: '9.	بند عام:',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.1.	Edenred will not be liable to the Customer for any delay or failure to fulfill its obligations under this Agreement to the extent that any such delay or failure arises from causes beyond its reasonable control including, without limitation, acts of terrorism, fire, floods, acts of God, acts or regulations of any governmental authority, war, riots, or strikes.',
            },
            [LANGUAGES.arabic]: {
                text: '1.9	 لن تكون شركة ايدنريد مسؤولة حيال العميل عن أي تأخير أو فشل في استيفاء التزاماتها بموجب هذه الاتفاقية إلى الحد الذي يكون فيه أي تأخير أو فشل ناشئ خارج نطاق سيطرتها المعقولة بما في ذلك، على سبيل المثال لا الحصر، أعمال الإرهاب أو الحرائق أو القضاء والقدر أو أعمال أو تنظيمات أي سلطة حكومية أو حرب أو أعمال شغب أو إضرابات.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.2.	Both parties shall (and will ensure that its personnel shall) keep confidential all information of the other party unless otherwise agreed in writing or the disclosure of such confidential information is permitted by law or disclosed to professional advisors.',
            },
            [LANGUAGES.arabic]: {
                text: '2.9 يحافظ كلا الطرفين (وسيضمنان أن يحافظ موظفيهما) على سرية كافة المعلومات الخاصة بالطرف الآخر ما لم يتم الاتفاق على خلاف ذلك خطيًا أو يُسمح بالكشف عن هذه المعلومات السرية بموجب القانون أو يتم الكشف عنها للمستشارين المهنيين. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.3.	All communication, C3Pay Payroll Cards, notices, invoices, demands or other documents under this Agreement may be delivered personally to either party, sent by courier or email to the other party to their respective addresses.',
            },
            [LANGUAGES.arabic]: {
                text: '3.9.	يجوز تسليم كافة الإرساليات أو بطاقات كشوف المرتبات C3Pay أو الإخطارات أو الفواتير أو الطلبات أو الوثائق الأخرى بموجب هذه الاتفاقية شخصيًا إلى أي من الطرفين أو إرسالها بالبريد السريع أو البريد الإلكتروني للطرف الآخر على عناوينهم الخاصة بهم.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.4.	The Customer shall provide the necessary approvals to Edenred when requested for delivering & distribution of Cards at the premises of the Customer or the Customer’s staff accommodation.',
            },
            [LANGUAGES.arabic]: {
                text: '4.9.	يقوم العميل بتقديم الموافقات اللازمة لشركة ايدنريد عند الطلب لتسليم وتوزيع البطاقات في مقر العميل أو مكان إقامة موظفي العميل. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.5.	Any delay or omission by any party in exercising or enforcing (in whole or in part) any right or remedy arising under this Agreement shall not be construed as a waiver of such right or remedy.',
            },
            [LANGUAGES.arabic]: {
                text: '5.9.	لا يتم تفسير أي تأخير أو إغفال من قبل أي طرف في ممارسة أو إنفاذ (كليًا أو جزئيًا) لأي حق أو تعويض ناشئ بموجب هذه الاتفاقية على أنه تنازل عن هذا الحق أو التعويض.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.6.	If any of the provisions under this Agreement is or becomes illegal or unenforceable, the remaining provisions shall continue in full force and effect.',
            },
            [LANGUAGES.arabic]: {
                text: '6.9.	إذا كانت أي من الأحكام في هذه الاتفاقية غير قانونية أو أصبحت غير قانونية أو غير قابل للتنفيذ، تظل الأحكام المتبقية سارية المفعول والتأثير بالكامل.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.7.	No variation, extension or cancellations of this Agreement shall be binding upon either party unless agreed in writing by both parties.',
            },
            [LANGUAGES.arabic]: {
                text: '7.9.	لن يكون أي تغيير أو تمديد أو إلغاء لهذه الاتفاقية ملزمًا لأي من الطرفين ما لم يتم الاتفاق خطيًا من قبل الطرفين. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.8.	If at any time a dispute arises in connection with this Agreement, representatives of the Customer and Edenred shall in the first instance meet in good faith with a view to resolving the dispute within a period of fifteen (15) working days from the day the dispute first arises. Should the parties fail to resolve the dispute amicably, then either party shall have a right to refer the matter to their appropriate levels of senior management for resolution. ',
            },
            [LANGUAGES.arabic]: {
                text: '8.9.	في حال نشوء نزاع في أي وقت فيما يتصل بهذه الاتفاقية، يجتمع ممثلو العميل وشركة ايدنريد في الأول بحسن نية بهدف حل النزاع في غضون خمسة عشر (15) يوم عمل من اليوم الذي نشأ فيه النزاع لأول مرة. في حال فشل الطرفين لحل النزاع وديًا، يحق لأي من الطرفين إحالة الأمر إلى المستويات المناسبة لكل منهما من الإدارة العليا لحلها.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.9.	This Agreement is governed by the laws of the Emirate of Dubai and the laws of the United Arab Emirates and the parties submit to the exclusive jurisdiction of the Dubai Courts.',
            },
            [LANGUAGES.arabic]: {
                text: '9.9.	تخضع هذه الاتفاقية لقوانين إمارة دبي وقوانين الإمارات العربية المتحدة ويخضع الطرفان للاختصاص القضائي الحصري لمحاكم دبي. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '9.10.	All disputes arising out of or in connection with the present Agreement shall be settled amicably by sincere efforts of both Parties hereto, but if and when such disputes cannot be so settled, within 60 (sixty) days after occurrence of such disputes, then such disputes shall be, by the request of either Party, finally settled in the Dubai Courts. ',
            },
            [LANGUAGES.arabic]: {
                text: '10.9.	تتم تسوية كافة النزاعات الناشئة عن أو فيما يتعلق بهذه الاتفاقية وديًا من خلال الجهود المخلصة لكلا الطرفين بموجب هذه الاتفاقية، ولكن إذا وعندما يتعذر تسوية تلك النزاعات في غضون 60 (ستين) يومًا بعد حدوث تلك النزاعات، تتم تسويتها، بناءًا على طلب أي من الطرفين، نهائيًا في محاكم دبي. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.	Service Level',
            },
            [LANGUAGES.arabic]: {
                text: '10.	مستوى الخدمة',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.1.	Service Implementation & Customer Onboarding',
            },
            [LANGUAGES.arabic]: {
                text: '1.10	تنفيذ الخدمة وتسجيل العملاء',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.1.1.	Customer Meetings – Edenred shall undertake to provide representation at customer meetings to discuss implementation concerns.  The Customer will undertake to arrange such meetings by serving a written notice in advance to Edenred.',
            },
            [LANGUAGES.arabic]: {
                text: '1.1.10	اجتماعات العملاء - تتعهد شركة ايدنريد بتوفير التمثيل في اجتماعات العملاء لمناقشة المخاوف الخاصة بالتنفيذ. يتعهد العميل بترتيب تلك الاجتماعات من خلال تقديم إشعار خطي مسبق إلى شركة ايدنريد.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.1.2.	Commencement Date – Edenred shall agree the relevant commencement with the customer during the implementation meetings.',
            },
            [LANGUAGES.arabic]: {
                text: '2.1.10	تاريخ البدء – يتعين على شركة ايدنريد أن توافق على تاريخ البدء ذي الصلة مع العميل خلال اجتماعات التنفيذ. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.2.	On-going Service',
            },
            [LANGUAGES.arabic]: {
                text: '2.10	  الخدمة المستمرة',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.2.1.	Customer Service – Edenred shall provide on-going customer service to the Customer and its Employees in the form of customer meetings, telephone conferences and helpdesks.',
            },
            [LANGUAGES.arabic]: {
                text: '1.2.10	خدمة العملاء - تقدم شركة ايدنريد خدمة عملاء مستمرة للعميل وموظفيه في شكل اجتماعات العملاء والمؤتمرات عبر الهاتف ومكاتب المساعدة.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.2.2.	Issues – Edenred shall undertake to investigate and remedy all valid issues reported by the Customer within a reasonable time.  The Customer shall undertake to report any issues and concerns as soon as practically possible.',
            },
            [LANGUAGES.arabic]: {
                text: '2.2.10	الإشكاليات - تتعهد شركة ايدنريد بالتحقيق في ومعالجة كل الإشكاليات الحقيقية والمشروعة التي أبلغ عنها العميل في غضون فترة زمنية معقولة. يتعهد العميل بالإبلاغ عن أي إشكاليات ومخاوف في أقرب وقت ممكن عمليًا. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.3.	Reports and Invoicing',
            },
            [LANGUAGES.arabic]: {
                text: '3.10.	التقارير والفواتير',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.3.1.	Invoicing – Edenred shall undertake to provide relevant invoicing for each month’s activities.',
            },
            [LANGUAGES.arabic]: {
                text: '1.3.10	الفوترة - تتعهد شركة ايدنريد بتوفير الفواتير ذات الصلة الخاصة بأنشطة كل شهر. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.3.2.	Processing of Payroll File/Payment Date –Edenred shall ensure that the Salaries are loaded into the C3Pay Payroll Cards by the next working day after receiving funds before the WPS Cut-Off Time of 14:30 PM. ',
            },
            [LANGUAGES.arabic]: {
                text: '2.3.10	معالجة ملف كشوف المرتبات/ تاريخ الدفع - تضمن شركة ايدنريد أن يتم تحميل المرتبات في بطاقات كشوف المرتبات C3Pay بحلول يوم العمل التالي بعد تلقي الأموال قبل آخر موعد لقيد ودائع في حساب عميل لبنك عبر نظام حماية الأجور والذي هو 14:30 مساءًا. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.3.3.	Confirmation of Successful Payment – Edenred shall provide confirmation to the Customer on the Payment Date that the payroll has been successfully processed and the relevant Salaries loaded into the C3Pay payroll cards.',
            },
            [LANGUAGES.arabic]: {
                text: '3.3.10	تأكيد الدفع الناجح - تقدم شركة ايدنريد تأكيدًا للعميل في تاريخ الدفع بأنه تمت معالجة كشوف المرتبات بنجاح وتحميل المرتبات ذات الصلة في بطاقات كشوفات المرتبات C3Pay. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '10.3.4.	Issues with Payroll File – Edenred undertake to make all necessary validations and checks on all submitted Payroll Files and report any discrepancies on Edenred payroll portal. ',
            },
            [LANGUAGES.arabic]: {
                text: '4.3.10	المشكلات الخاصة بملف المرتبات - تتعهد شركة ايدنريد بإجراء كافة عمليات المصادقة والتحقق اللازمة على كافة ملفات كشوف المرتبات المقدمة والإبلاغ عن أي تباينات عبر بوابة كشوف المرتبات الخاصة بشركة ايدنريد. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '11.	Know Your Customer (KYC)',
            },
            [LANGUAGES.arabic]: {
                text: '11.	اعرف عميلك',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '11.1.	Customer will be liable to provide all the necessary KYC documents in regards to the company registration and authorized signatories at the time of signing of this Agreement',
            },
            [LANGUAGES.arabic]: {
                text: '1.11	يكون العميل مسؤولاً عن تقديم كافة مستندات "اعرف عميلك" الضرورية فيما يخص تسجيل الشركة والمفوضين بالتوقيع في وقت توقيع هذه الاتفاقية.  ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '11.2.	Customer shall be liable, to either provide all the necessary KYC documents for their employees applying for a C3Pay Payroll Card, or alternatively support their Employees in providing the same directly to Edenred at time of distribution of the cards.',
            },
            [LANGUAGES.arabic]: {
                text: '2.11	 يكون العميل مسؤولاً، إما عن تقديم كل مستندات "اعرف عميلك" الضرورية الخاصة بموظفيه الذين يطلبون الحصول على بطاقة كشوف الروتب C3Pay ، أو بدلاً من ذلك دعم موظفيه في تقديم تلك المستندات مباشرةً إلى شركة ايدنريد في وقت توزيع البطاقات.  ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '11.3.	Customer must make an effort in informing Edenred at the time of termination of the Employee ',
            },
            [LANGUAGES.arabic]: {
                text: '3.11	يجب على العميل إبلاغ شركة ايدنريد في الوقت المناسب بإنهاء خدمات الموظف. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '12.	Indemnity',
            },
            [LANGUAGES.arabic]: {
                text: '12.	التعويض',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '12.1.	The Customer agrees to indemnify, defend and hold harmless Edenred, its holding company, affiliates, subsidiaries and their representatives, officers, employees, contractors, assigns and agents indemnified from and against all losses arising in connection with this Agreement, including, without limitation, in connection with any breach of this Agreement by the  Customer, any Card Application, any C3Pay Payroll Cards, any payment to any C3Pay Payroll Cards, any Payroll Account, any Payroll File, the Intellectual Property Rights, any fraud, act or omission of the Customer, the Employees or any other third party. ',
            },
            [LANGUAGES.arabic]: {
                text: '1.12	يوافق العميل على تعويض والدفاع عن وتعويض تضرر شركة ايدنريد وشركتها القابضة وشركاتها التابعة وشركاتها الفرعية وممثليها ومسؤوليها وموظفيها ومقاوليها والمتنازل لهم والوكلاء الذين يتم تعويضهم عن وضد كافة الخسائر الناشئة فيما يتعلق بهذه الاتفاقية، بما في ذلك من دون حصر، فيما يتعلق بأي خرق لهذه الاتفاقية من قبل العميل، أو أي طلب للبطاقة، أو أي بطاقات كشوف المرتباتC3Pay ، وأي مدفوعات لأي بطاقات كشوف المرتبات C3Pay، وأي حساب كشوف مرتبات، أو أي ملف كشوف مرتبات، أو حقوق ملكية فكرية، أو أي احتيال أو فعل أو إغفال من طرف العميل أو الموظفين أو أي طرف ثالث آخر. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '12.2.	In case Edenred cannot deliver a Card to the Cardholder, the Company takes the responsibility to deliver the Card to the Cardholder and keep the record of delivery of such Cards. ',
            },
            [LANGUAGES.arabic]: {
                text: '2.12	 في حال لم تتمكن شركة ايدنريد من تسليم البطاقة إلى صاحبها، تتحمل الشركة مسؤولية تسليم البطاقة إلى حامل البطاقة والاحتفاظ بسجل تسليم هذه البطاقات. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '12.3.	Customer shall take full responsibility of the Cards upon taking delivery of the Cards from Edenred representative. ',
            },
            [LANGUAGES.arabic]: {
                text: '3.12	 يتحمل العميل المسؤولية الكاملة عن البطاقات عند استلامها من ممثل شركة ايدنريد. ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '13.	Data Protection',
            },
            [LANGUAGES.arabic]: {
                text: '13.	 حماية البيانات ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '13.1.	Edenred undertakes to be the Data Controller of all personal data procured as a consequence of the performance of activities outlined in this Agreement or any subsequent Amendments to this Agreement. ',
            },
            [LANGUAGES.arabic]: {
                text: '13.1 تمثل إيدنريد مراقب البيانات الشخصية التي تم جمعها نتيجة لأداء الأنشطة الموضحة في هذه الاتفاقية أو أي تعديلات لاحقة على هذه الاتفاقية.',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '13.2.	The Customer acknowledges and agrees that the storage of such data specified in Clause 13.1 is undertaken by the Third-Party Card Processing Company affiliated with Edenred.',
            },
            [LANGUAGES.arabic]: {
                text: '13.2  يقر العميل ويوافق على أن البيانات المخزنة والمحددة فى البند 13.1 يتم معالجتها عن طريق طرف ثالث وهى شركة معالجة البيانات التابعة لشركة إيدنريد  ',
            },
        },
        {
            [LANGUAGES.english]: {
                text: '13.3.	Edenred agrees to execute its role as specified in Clause 13.1 in compliance with the provisions of the applicable Data Protection Laws of the UAE.',
            },
            [LANGUAGES.arabic]: {
                text: '13.3 توافق شركة إيدينريد على تنفيذ دورها على النحو المحدد فى البند 13.1 بما يتوافق مع أحكتم قوانين حماية البيانات المعمول به فى دولة الإمارات العربية المتحدة ',
            },
        },
    ],
});
